export const initialState = {
  fleet: new Array(55).fill(1)
};
